import styled from 'styled-components';

const ProgressList = styled.ul`
  margin: 16px 0 24px 0;
`;

export default ProgressList;
